"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDateTimeWithFormat = void 0;
var tslib_1 = require("tslib");
var isNumber_1 = (0, tslib_1.__importDefault)(require("lodash/fp/isNumber"));
var isString_1 = (0, tslib_1.__importDefault)(require("lodash/fp/isString"));
var isDate_1 = (0, tslib_1.__importDefault)(require("lodash/fp/isDate"));
var isNil_1 = (0, tslib_1.__importDefault)(require("lodash/fp/isNil"));
var stubTrue_1 = (0, tslib_1.__importDefault)(require("lodash/fp/stubTrue"));
var cond_1 = (0, tslib_1.__importDefault)(require("lodash/fp/cond"));
var identity_1 = (0, tslib_1.__importDefault)(require("lodash/fp/identity"));
var fp_1 = require("date-fns/fp");
var throwDateTimeError = function () {
    throw new Error('Invalid input parameter supplied to getDateTime');
};
var parseFromTimestamp = (0, fp_1.parse)(new Date(), 'T');
var getCurrentTime = function () { return parseFromTimestamp(Date.now().toString()); };
var getDateTime = (0, cond_1.default)([
    [isNil_1.default, getCurrentTime],
    [isNumber_1.default, function (arg) { return parseFromTimestamp(arg.toString()); }],
    [isString_1.default, fp_1.parseISO],
    [isDate_1.default, identity_1.default],
    [stubTrue_1.default, throwDateTimeError],
]);
var getDateTimeWithFormat = function (format, input) {
    return (0, fp_1.parse)(getDateTime(), format, input);
};
exports.getDateTimeWithFormat = getDateTimeWithFormat;
exports.default = getDateTime;
